import { useSelector } from 'react-redux';

import { areGenCondAccepted, isAuthenticatedSelector } from '»components/Auth';

export const useUserAuthentication = () => {
  const isAuthenticated = useSelector(isAuthenticatedSelector);
  const generalCond = useSelector(areGenCondAccepted);

  // eslint-disable-next-line no-undef
  const myConfig = config();
  const { showTermsAndConditions } = myConfig;

  if (showTermsAndConditions)
    return { isUserAuthenticated: isAuthenticated && generalCond === 'Y' };

  return { isUserAuthenticated: isAuthenticated };
};
